/**
 * A no-operation (noop) function that performs no action when invoked.
 * This can be used as a placeholder or default function where no operation is required.
 */
export const doNothing = () => {
  // do nothing
}
